import React from "react";
import Icon from "react-icons-kit";
import { ic_error } from "react-icons-kit/md/ic_error";
import "../../assets/css/components/InvalidToken/InvalidToken.css";
import { observer } from "mobx-react";

const InvalidToken =(observer((store) => {
    const {
      location: { state },
    } = store;
    return state && state.token ? (
      <div className="invalid_wrapper">
        <div className="container">
          <div className="invaid_contant">
            <div className="invalidleft">
              <span className="error_icons">
                <Icon size={40} icon={ic_error} />
              </span>
            </div>
            <div className="invalidright">
              <div className="ErrorSection">Invalid token.</div>
              <p className="errortxt">
                Please retry your request or contact product@izenda.com for
                assistance.
              </p>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div>Page Not Found</div>
    );
  }))

export default InvalidToken;



// WEBPACK FOOTER //
// ./src/components/InvalidToken/InvalidToken.jsx